import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

const Appointment = () => {
  return (
    <div className="it-appointment-area">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="it-appointment-wrapper d-flex align-items-center justify-content-between tertiary-bg">
              <h3 className="it-appointment-title text-white">
                Need A Doctor For Check-Up?
              </h3>
              <Link className="it-btn-theme black-bg" to="/appointment">
                <Button btnText="Book an appointment" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appointment;
